import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TableColType } from '@shared/enums/table.enum';
import { IEmailActivity } from '@shared/interfaces/email-activity.interface';
import { IReference } from '@shared/interfaces/reference.interface';
import { ITableCol } from '@shared/interfaces/table.col.interface';
import { LoggerService } from '@shared/services/logger.service';
import { ReferencesService } from '@shared/services/references.service';

@Component({
    selector: 'app-sidebar-reference-emails',
    templateUrl: './sidebar.reference.emails.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidebarReferenceEmailsComponent implements OnInit {
  @Input() private reference: IReference;

  public isLoading = Boolean(true);

  public rows: IEmailActivity[] = [];
  public cols: Partial<ITableCol>[] = [
    {
      headerText: 'TABLES.HEADERS.STATUS',
      type: TableColType.Icon,
      cellClassName: 'text-capitalize',
      selector: 'label'
    },
    {
      headerText: 'TABLES.HEADERS.EMAIL',
      type: TableColType.Text,
      selector: 'email'
    },
    {
      headerText: 'TABLES.HEADERS.DESCRIPTION',
      cellClassName: 'text-wrap',
      type: TableColType.Text,
      selector: 'message',
      selectorFunction: (data: string) => data || '-'
    },
    {
      headerText: 'TABLES.HEADERS.DATE',
      type: TableColType.Ago,
      selector: 'created_at'
    }
  ];

  private readonly constructorName: string = String(this.constructor.name);

  constructor(
    private readonly _logger: LoggerService,
    private readonly _references: ReferencesService
  ) {}

  ngOnInit(): void {
    this.getEmails();
  }

  public getEmails(): void {
    const id = this.reference?.id;
    const url = `GET /references/${id}/email_activities`;
    this._references.getReferenceEmailActivities(id).subscribe(
      (res: IEmailActivity[]) => {
        this._logger.info(this.constructorName, url, res);

        this.rows = res;
        this.isLoading = false;
      },
      (err: any) => {
        this._logger.error(this.constructorName, url, err);

        this.isLoading = false;
      }
    );
  }

  public trackByFn(i: any): string {
    return i.id;
  }
}
